export const getUserDisplayName = (user) => {
    if (!user) return 'Utilisateur';
    
    if (user.displayName && user.displayName.trim()) {
        return user.displayName.trim();
    }
    
    if (user.profile && user.profile.firstName && user.profile.lastName) {
        return `${user.profile.firstName} ${user.profile.lastName}`;
    }
    
    if (user.profile && user.profile.name && user.profile.name.trim()) {
        return user.profile.name.trim();
    }
    
    if (user.email) {
        const emailName = user.email.split('@')[0];
        return emailName
            .replace(/[._]/g, ' ')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }
    
    return 'Utilisateur';
};

export const getInitials = (name) => {
    if (!name) return 'U';
    
    return name
        .split(' ')
        .map(word => word.charAt(0))
        .join('')
        .toUpperCase()
        .substring(0, 2);
};

export const getAvatarColor = (name) => {
    if (!name) return '#e67e22';
    
    const colors = [
        '#e67e22', '#3498db', '#2ecc71', '#9b59b6', 
        '#f39c12', '#e74c3c', '#1abc9c', '#34495e',
        '#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4',
        '#ffeaa7', '#fab1a0', '#fd79a8', '#a29bfe'
    ];
    
    const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const index = hash % colors.length;
    
    return colors[index];
};

export const formatUserForDisplay = (user) => {
    const displayName = getUserDisplayName(user);
    
    return {
        ...user,
        displayName,
        initials: getInitials(displayName),
        avatarColor: getAvatarColor(displayName)
    };
};